import React from 'react'
import { useTranslation } from 'react-i18next'
import {Col, Row} from 'antd'
import classNames from 'classnames'
import {Icon} from '@/components'
import {Currencies} from '@/constants'
import { getAmountWithCurrency } from '@/utils'
import styles from './styles.scss'

type Props = {
    income: number
    outgoing: number
    incomeCurrency: Currencies
    outgoingCurrency: Currencies
}

export const IncomeOutcome: React.FC<Props> = (
    {income, outgoing, incomeCurrency, outgoingCurrency}
) => {
    const { t } = useTranslation()
    return (
        <Row className={styles.container}>
            <Col className={classNames(styles.income, styles.text)}>
                <Icon type={'arrow_up'}/>
                {t('IncomeOutcome.income', { amountWithCurrency: getAmountWithCurrency(income, incomeCurrency) })}
            </Col>
            <Col className={classNames(styles.outgoing, styles.text)}>
                <Icon type={'arrow_down'}/>
                {t('IncomeOutcome.outgoing', { amountWithCurrency: getAmountWithCurrency(outgoing, outgoingCurrency) })}
            </Col>
        </Row>
    )
}
